module.exports = __webpack_public_path__ + "static/media/upcoming-white.3224c5b1.svg";